export const colors = {
    red: 'red',
    green: 'green',
    purple: 'purple',
    white: 'white',
    transparent: 'transparent',
    blue: 'blue',
}

export const WARNING_MESSAGES = {
    TOO_MANY_SEATS: 'TOO_MANY_SEATS',
    DIFFERENT_CINEMA: 'DIFFERENT_CINEMA',
}
